import {Component} from "react";
import * as React from "react";

import {IconButton} from "office-ui-fabric-react";
import {SubjectItem} from "./OnboardSubjectMergePage/SubjectItem";

export interface SelectableSubjectCardProps
{
    className?: string;
    subjectItem: SubjectItem;
    selected: boolean;
    selectedClassName?: string;
    iconName: string;
    iconLabel: string;
    toggleSelected(code: string): void;
}

interface SelectableSubjectCardState
{
}

export default class SelectableSubjectCard extends Component<SelectableSubjectCardProps,SelectableSubjectCardState>
{

    constructor(props: Readonly<SelectableSubjectCardProps>) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }
    
    public render() {
        
        let className = `${this.props.className ? this.props.className : ""} subject-card`;
        if(this.props.selected)
        {
            if(this.props.selectedClassName)
            {
                className = `${className} ${this.props.selectedClassName} subject-card--excluded`;

            }
            else
            {
                className = `${className} subject-card--selected`;
            }
        }
        
        return (
            <div className={className}>
                <div className={"subject-card__content"}>
                    <div className={"subject-card__header"}>
                        <div className={"flex-column flex-item--flex-1"}>
                            <span>{this.props.subjectItem.name}</span>
                            <span className={"subject-card__subject-code"}>{this.props.subjectItem.code}</span>
                        </div>
                        <IconButton className={"m-left-auto"} iconProps={{iconName: this.props.iconName}} title={this.props.iconLabel} ariaLabel={this.props.iconLabel}  onClick={() => this.props.toggleSelected(this.props.subjectItem.code)}/>
                    </div>

                </div>

            </div>
        );
    }
}